<template>
  <div>
    <pricing @success="membershipSelected"></pricing>
  </div>
</template>

<script>
  /* Start of lazy load components config */
  import lazyLoadComponent from '@/util/lazy-load-component'
  import Preloader from '@/app/global/components/Preloader'
  // import SkeletonBox from '@/app/global/components/SkeletonBox'
  const lazyLoadOptions = {
    loading: Preloader,
    loadingData: {
      props: {
        width: '100%',
        height: '2rem'
      }
    }
  }
  /* End of lazy load components config */

  export default {
    name: 'PricingPage',
    components: {
      Pricing: lazyLoadComponent({...lazyLoadOptions, componentFactory: () => import('@/app/account/components/Pricing')})
    },
    data () {
      return {
        errors: {},
        premiumModalShow: false
      }
    },
    methods: {
      membershipSelected () {

      }
    },
    mounted () {
      // this.$el.addEventListener('click', this.onClose)
    }
  }
</script>

<style lang="scss" scoped>

</style>
